import {Component, OnInit, ViewContainerRef, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TableService} from "../../shared/services/table/table.service";
import {Restaurant} from "../../shared/model/restaurant";
import {Table} from "../../shared/model/table";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from "angular2-modal";
import {AuthService} from "../../shared/security/auth.service";
import {TableChangeLog} from "../../shared/model/tableChangeLog";

@Component({
  selector: 'table-edit',
  templateUrl: 'table-edit.component.html',
  styleUrls: ['table-edit.component.css']
})
export class TableEditComponent implements OnInit {
  table:Table;
  tableChangeLog:TableChangeLog;

  restaurantEmitter = new EventEmitter<Restaurant>()

  constructor(
              private tableservice:TableService,
              private authService:AuthService,
              private route: ActivatedRoute,
              private router: Router,
              public modal:Modal,
              overlay: Overlay,
              vcRef:ViewContainerRef
  ) {

    this.route.data
      .subscribe(
        ( data : {table:Table  }) =>
        {

          this.table = data.table;

        }
      )



  }

  ngOnInit() {
  }

  cancel(){

    // console.log(this.table);

  this.router.navigate(['/restaurants/'+this.table.restaurant_id])
}
  save(table:Table){

    // console.log(this.table);

    let restaurant$Key = this.table.restaurant_id;
    let currentStatus = this.table.status;

    // console.log(restaurant$Key);

    this.table.isActive = table.isActive;
    this.table.tableName = table.tableName;
    this.table.status = table.status;
    this.table.statusStartedTime = String(new Date().getTime() / 1000);
    this.table.statusForTable = "<span class=\"status-class "+table.status+"\">"+table.status+"</span>";
    this.table.seats = table.seats;

    this.tableChangeLog = Object.assign({});

    this.tableChangeLog.restaurant_id = restaurant$Key;
    this.tableChangeLog.table_id = this.table.$key;
    this.tableChangeLog.previousStatus = currentStatus;
    this.tableChangeLog.nextStatus = table.status;
    this.tableChangeLog.changeDateTiemTime = String(new Date().getTime() / 1000);
    this.tableChangeLog.user_id = this.authService.getUid();

    const tableSave$ = this.tableservice.saveTable(this.table);
    tableSave$
      .subscribe(()=>{
        const tableLogCreate$ = this.tableservice.createTableChageLog(this.tableChangeLog);
        tableLogCreate$
          .subscribe(()=>{
            this.router.navigate(['/restaurants/'+this.table.restaurant_id]);
          });
      }, err => this.messageIt('Error Editing a Table',err))


  }

  deleteEvent(){
    let deleteTable ={ table:
      {
        "deleteedDateTime": new Date().toISOString(),
        "deletedBy":this.authService.getUid(),
        "restauramtID":this.table.restaurant_id,
        "tableName":this.table.tableName,
        "seats":this.table.seats
      }
    }
    const deleteTables$ = this.tableservice.createDeleteLog(deleteTable);
    deleteTables$
      .subscribe(()=>{
              const tableDelete$ = this.tableservice.deleteTable(this.table)
              tableDelete$
                .subscribe(()=>{
                  this.router.navigate(['/restaurants/'+this.table.restaurant_id])
                }, err => this.messageIt('Error Deleting a Table',err))

          }, err => this.messageIt('Error Deleting a Table',err))

  }


  _cleanup(){
  }


  delete(){

    this.modal.confirm()
      .size('lg')
      .showClose(true)
      .title('Deleting Table '+this.table.tableName)
      .body('Please OK to Delete this table?')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => { return dialog.result })
      .then((result: any) => { this.deleteEvent() })
      .catch((err: any) => this._cleanup());

  }


  messageIt(titleP: string, messageP: string) {

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }





}



// WEBPACK FOOTER //
// ./src/app/table/table-edit/table-edit.component.ts